// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .form-link-image {\n    display: flex;\n  }\n  .root .align--center .form-link-image {\n    justify-content: center;\n  }\n  .root .align--right .form-link-image {\n    justify-content: right;\n  }\n  [dir='rtl'] .root .align--left .form-link-image {\n      justify-content: right;\n    }\n  .root .align--left .form-link-image {\n    justify-content: left;\n}\n", ""]);
// Exports
module.exports = exports;
